import {
  TBanner,
  TSegment,
  TgetBannerImagesParams,
} from '../utils/types';
import { emptySplitApi } from './emptySplitApi';

export const promotionsService = emptySplitApi
  .enhanceEndpoints({ addTagTypes: ['BannerList'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getBannerImages: builder.query<
        { data: TBanner[]; totalCount: number },
        TgetBannerImagesParams
      >({
        query: (params) => ({
          method: 'GET',
          url: `${
            params.widgetType === 'SQUARE_BANNER'
              ? 'widget'
              : 'banners'
          }?isActive.equals=1`,
          params,
        }),
        transformResponse: (
          data: TBanner[],
          meta: Response
        ) => {
          const totalCount =
            meta.headers.get('X-total-count');
          return {
            data,
            totalCount: Number(totalCount ? totalCount : 0),
          };
        },
        providesTags: ['BannerList'],
      }),
      getSegmentList: builder.query<TSegment[], void>({
        query: () => ({
          method: 'GET',
          url: 'banner/userSegments',
        }),
      }),
      updateSquareBanner: builder.mutation<void, TBanner>({
        query: (data) => {
          return {
            url: 'widget',
            method: 'PUT',
            data,
          };
        },
        invalidatesTags: ['BannerList'],
      }),
      removeBanner: builder.mutation<void, TBanner>({
        query: (data) => {
          return {
            url: 'banners/v2',
            method: 'PUT',
            data,
          };
        },
        invalidatesTags: ['BannerList'],
      }),
    }),
  });

export const {
  useGetBannerImagesQuery,
  useGetSegmentListQuery,
  useUpdateSquareBannerMutation,
  useRemoveBannerMutation,
} = promotionsService;
